import React from 'react';
import { StepViewModel } from '../../models/step';
import { InputType } from '../../enums/input-type.enum';
import { ColorPickerViewRender } from '../../views/ColorPickerViewRender';
import { Option } from '../../models/option';
import { StepValues } from '../../models/step-values';
import { ProductHandle } from '../../../enums/ProductHandle.enum';
import { FinalSizeViewRender } from '../../views/FinalSizeViewRender';
import { BraSizePickerViewRender } from '../../views/BraSizePickerViewRender';
import { Size } from '../../enums/size.enum';

export const SculptwearSteps: StepViewModel[] = [
  {
    key: 'dress',
    text: "What's your dress size?",
    options: [
      {
        text: "I don't know",
        nextStepKey: 'do-you-know-waist',
      },
      {
        text: '0',
        nextStepKey: 'dress-additional',
      },
      {
        text: '2',
        nextStepKey: 'dress-additional',
      },
      {
        text: '4',
        nextStepKey: 'dress-additional',
      },
      {
        text: '6',
        nextStepKey: 'dress-additional',
      },
      {
        text: '8',
        nextStepKey: 'dress-additional',
      },
      {
        text: '10',
        nextStepKey: 'dress-additional',
      },
      {
        text: '12',
        nextStepKey: 'dress-additional',
      },
      {
        text: '14',
        nextStepKey: 'dress-additional',
      },
      {
        text: '16',
        nextStepKey: 'dress-additional',
      },
      {
        text: '18',
        nextStepKey: 'dress-additional',
      },
      {
        text: '20',
        nextStepKey: 'dress-additional',
      },
      {
        text: '22',
        nextStepKey: 'dress-additional',
      },
      {
        text: '24',
        nextStepKey: 'dress-additional',
      },
    ],
  },
  {
    key: 'dress-additional',
    text: 'Do you always wear size {dress}?',
    options: [
      {
        text: 'Yes, I always wear size {dress}',
        nextStepKey: 'do-you-know-waist',
      },
      {
        text: 'No, I sometimes wear a different size',
        nextStepKey: 'dress-other',
      },
    ],
  },
  {
    key: 'dress-other',
    text: 'What other size do you sometimes wear?',
    filter: (option: Option, stepValues: StepValues, productHandle: ProductHandle): boolean => {
      const dressSize = stepValues.get('dress');
      return !(dressSize?.text === '0' && option.text?.startsWith('{dress-'));
    },
    options: [
      {
        text: '{dress-2}',
        nextStepKey: 'do-you-know-waist',
      },
      {
        text: '{dress+2}',
        nextStepKey: 'do-you-know-waist',
      },
    ],
  },
  {
    key: 'do-you-know-waist',
    text: 'Do you know your waist measurement?',
    progress: 0,
    options: [
      {
        text: 'Yes',
        nextStepKey: 'waist-instructions',
      },
      {
        text: 'No',
        nextStepKey: 'bra',
      },
    ],
  },
  {
    key: 'waist-instructions',
    text: 'Please measure your waist as shown below:',
    subText:
      'Waist measurements should be taken at the natural waist, the smallest point of the torso. It is usually a few inches below your bust, and a couple inches above your belly button.',
    // loadingSpinnerMs: 100,
    image: 'measure-waist.svg',
    options: [
      {
        text: 'CONTINUE',
        inputType: InputType.CTAButton,
        nextStepKey: 'waist-measurement',
      },
    ],
  },
  {
    key: 'waist-measurement',
    text: 'What is your waist measurement?',
    options: [
      {
        imperialText: '25" or lower',
        metricText: '64 cm or lower',
        nextStepKey: 'bra',
      },
      {
        imperialText: '26"',
        metricText: '66 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '27"',
        metricText: '69 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '28"',
        metricText: '71 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '29"',
        metricText: '74 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '30"',
        metricText: '76 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '31"',
        metricText: '79 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '32"',
        metricText: '81 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '33"',
        metricText: '84 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '34"',
        metricText: '86 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '35"',
        metricText: '89 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '36"',
        metricText: '91 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '37"',
        metricText: '94 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '38"',
        metricText: '97 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '39"',
        metricText: '99 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '40"',
        metricText: '102 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '41"',
        metricText: '104 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '42"',
        metricText: '107 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '43"',
        metricText: '109 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '44"',
        metricText: '112 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '45"',
        metricText: '114 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '46"',
        metricText: '117 cm',
        nextStepKey: 'bra',
      },
      {
        imperialText: '47" or higher',
        metricText: '119 cm or higher',
        nextStepKey: 'bra',
      },
    ],
  },
  {
    key: 'bra',
    text: 'We’ll now also ask you about your bra size because it helps us understand your body shape.',
    progress: 50,
    options: [
      {
        text: '',
        nextStepKey: 'shape',
      },
      {
        text: '',
        nextStepKey: 'shape',
      },
    ],
    render: (props, onChange) => {
      return (
        <BraSizePickerViewRender
          {...props}
          onChange={onChange}
          key={'bra'}
          nextStepKey={'shape'}
          braSizeLookupFn={() => Size.XS} // This will prevent the "not-ready" step from ever appearing
          unsupportedStepKey={'shape'} // This will prevent the "not-ready" step from ever appearing
        />
      );
    },
  },
  {
    key: 'shape',
    text: 'Which of these shapes best matches your curves?',
    options: [
      ...[
        {
          text: 'Apple',
          nextStepKey: 'height',
        },
        {
          text: 'Pear',
          nextStepKey: 'height',
        },
        {
          text: 'Hourglass',
          nextStepKey: 'height',
        },
        {
          text: 'Rectangle (or ruler)',
          nextStepKey: 'height',
        },
      ].sort(() => 0.5 - Math.random()), // Randomizes the order once on initial load // TODO: Make sure this works in SSR
      {
        text: 'None of the above',
        nextStepKey: 'height',
      },
    ],
  },
  {
    key: 'height',
    text: 'How tall are you?',
    options: [
      {
        imperialText: '5\'0" or below',
        metricText: '150 cm or below',
        nextStepKey: 'bmi-check',
      },
      {
        imperialText: '5\'1"',
        metricText: '155 cm',
        nextStepKey: 'bmi-check',
      },
      {
        imperialText: '5\'2"',
        metricText: '157 cm',
        nextStepKey: 'bmi-check',
      },
      {
        imperialText: '5\'3"',
        metricText: '160 cm',
        nextStepKey: 'bmi-check',
      },
      {
        imperialText: '5\'4"',
        metricText: '163 cm',
        nextStepKey: 'bmi-check',
      },
      {
        imperialText: '5\'5"',
        metricText: '165 cm',
        nextStepKey: 'bmi-check',
      },
      {
        imperialText: '5\'6"',
        metricText: '168 cm',
        nextStepKey: 'bmi-check',
      },
      {
        imperialText: '5\'7"',
        metricText: '170 cm',
        nextStepKey: 'bmi-check',
      },
      {
        imperialText: '5\'8"',
        metricText: '173 cm',
        nextStepKey: 'bmi-check',
      },
      {
        imperialText: '5\'9"',
        metricText: '175 cm',
        nextStepKey: 'bmi-check',
      },
      {
        imperialText: '5\'10"',
        metricText: '178 cm',
        nextStepKey: 'bmi-check',
      },
      {
        imperialText: '5\'11"',
        metricText: '180 cm',
        nextStepKey: 'bmi-check',
      },
      {
        imperialText: '6\'0" or above',
        metricText: '183 cm or above',
        nextStepKey: 'bmi-check',
      },
    ],
  },
  {
    key: 'bmi-check',
    text: 'Final question - in an effort to calculate your Body Mass Index, please let us know your weight.',
    subText: 'Needless to say, all data is kept strictly confidential.',
    options: [
      {
        text: 'I would prefer to skip this question',
        inputType: InputType.Radio,
        nextStepKey: 'results',
      },
      {
        text: 'I am comfortable sharing my weight',
        inputType: InputType.Radio,
        nextStepKey: 'bmi',
      },
    ],
  },
  {
    key: 'bmi',
    text: 'Final question - in an effort to calculate your Body Mass Index, please let us know your weight.',
    subText: 'Needless to say, all data is kept strictly confidential.',
    isWeightToggle: true,
    options: [
      {
        imperialText: 'Weight (pounds)',
        metricText: 'Weight (kg)',
        nextStepKey: 'results',
        inputType: InputType.Number,
      },
    ],
  },
  {
    key: 'results',
    text: '[engine]',
    progress: 95,
    options: [
      {
        text: '',
        nextStepKey: 'pick-a-color',
      },
    ],
    render: (props, onChange) => {
      return <FinalSizeViewRender {...props} nextStepKey="pick-a-color" onChange={onChange} />;
    },
  },
  {
    key: 'pick-a-color',
    text: 'pick-a-color',
    progress: 100,
    options: [],
    render: (props, onChange) => {
      return <ColorPickerViewRender {...props} onChange={onChange} />;
    },
  },
];
